// extracted by mini-css-extract-plugin
export var component = "TeaserLink-module--component--yE0Ag";
export var inert = "TeaserLink-module--inert--JQzwp";